export default "__VITE_ASSET__9d8b8819__"